import {Pipe} from "./../../models/Pipe";

let pipesApi = {
    async get(token, companyId, params={}){
        let response = await window.axios.get('/api/pipes', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data.map(pipe=>new Pipe(pipe));
    },
}

export default pipesApi;